<template>
  <filter-wrapper @submit="submit">
    <div class="filter__row">
      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('phone-number.number.field.number') }}
        </label>
        <div class="filter__item__body">
          <i-input v-model="form.number" type="number" :clearable="true" @on-clear="submit" />
        </div>
      </div>

      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('phone-number.number.field.country') }}
        </label>
        <div class="filter__item__body">
          <i-select
            v-model="form.country_iso"
            :loading="isLoading"
            :transfer="true"
            :filterable="true"
            :clearable="true"
            :multiple="true"
          >
            <i-option
              v-for="country in countriesList"
              :key="country.country_iso_code"
              :value="country.country_iso_code"
              :label="country.country_name"
            />
          </i-select>
        </div>
      </div>

      <div class="filter__item filter__item--datepicker col-6">
        <label class="filter__item__title">
          {{ $t('phone-number.number.field.activated_at') }}
        </label>
        <div class="filter__item__body">
          <date-range-picker v-model="form.date" />
        </div>
      </div>
    </div>

    <div class="filter__row">
      <div class="filter__item col-3" style="display: none">
        <label class="filter__item__title"> Тип номера </label>
        <div class="filter__item__body">
          <i-select v-model="form.is_custom" :clearable="true">
            <i-option
              v-for="(label, key, i) in $t('phone-number.number.is_custom')"
              :key="key"
              :value="i"
              :label="label"
            />
          </i-select>
        </div>
      </div>

      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('phone-number.number.field.type') }}
        </label>
        <div class="filter__item__body">
          <i-select v-model="form.type" :clearable="true" :multiple="true">
            <i-option
              v-for="(label, key) in $t('phone-number.number.type')"
              :key="key"
              :value="key"
              :label="label"
            />
          </i-select>
        </div>
      </div>

      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('shared.component.table.field.status') }}
        </label>
        <div class="filter__item__body">
          <i-select v-model="form.status" :clearable="true" :multiple="true">
            <i-option
              v-for="(label, key) in $t('phone-number.number.status')"
              :key="key"
              :value="key"
              :label="label"
            />
          </i-select>
        </div>
      </div>

      <div class="filter__item filter__item--button">
        <i-button html-type="submit" type="primary">
          {{ $t('shared.component.filter.show_result') }}
        </i-button>
      </div>
    </div>
  </filter-wrapper>
</template>

<script>
  import FilterWrapper from '@shared/components/filter-base';
  import { mapActions, mapGetters } from 'vuex';
  import { parseSearchStateByPeriod } from '@shared/helpers/date_format';

  export default {
    components: {
      FilterWrapper
    },

    data: () => ({
      form: {
        number: '',
        is_custom: null,
        country_iso: null,
        status: null,
        type: null,
        date: {
          start: null,
          end: null
        }
      }
    }),
    computed: {
      ...mapGetters('phone-number/user_countries/list', ['countries', 'isLoading']),
      countriesList() {
        return this.countries.map((i) => ({
          country_iso_code: i.iso,
          country_name: `${i.country} +${i.code}`
        }));
      }
    },

    created() {
      this.submit();
    },

    methods: {
      ...mapActions('phone-number/numbers/table', ['search']),

      submit: function () {
        const { start, end } = parseSearchStateByPeriod(this.form.date);
        const { number, status, type, is_custom, country_iso } = this.form;

        this.search({
          'filter[range][activated_at][from]': start,
          'filter[range][activated_at][to]': end,
          country_iso,
          number,
          status,
          type,
          is_custom
        });
      }
    }
  };
</script>
